<template>
  <div class="btn-col" @click="handleRecordClick">
    <a href="#" class="btn btn-secondary-outline" @click.prevent>
      <span class="btn-txt"
        ><span class="btn-icon record-icon"
          ><svg
            v-if="!isRecording"
            width="20"
            height="20"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="8" cy="8" r="6" stroke="#FF4444" stroke-width="2" />
            <circle cx="8" cy="8" r="3" fill="#FF4444" /></svg
          ><svg
            v-else
            width="20"
            height="20"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="3"
              y="3"
              width="10"
              height="10"
              rx="2"
              fill="#FF4444"
            /></svg></span
        >{{ buttonText }}</span
      >
    </a>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useAppStore } from "@/stores/app-store";

const appStore = useAppStore();

const isRecording = computed(() => {
  // TODO: Check actual recording state from recording store
  return false;
});

const buttonText = computed(() => {
  return isRecording.value ? "Recording..." : "Record";
});

const handleRecordClick = () => {
  if (isRecording.value) {
    // Navigate to existing recording
    // TODO: Get audioFileId from recording store
    // router.push(`/record/${audioFileId}`)
  } else {
    // Open recording popup to start new recording
    appStore.showRecordingPopup = true;
  }
};
</script>

<style lang="scss" scoped>
.record-icon {
  // Override font-size from .btn-icon since we're using SVG not icon font
  font-size: inherit;
}
</style>
